import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostHomemessage(action) {
	try {
		const result = yield fromApi.homemessagePost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_HOMEMESSAGE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetHomemessages(action) {
	try {
		const result = yield fromApi.homemessagesGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_HOMEMESSAGES_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutHomemessage(action) {
	try {
		const result = yield fromApi.homemessagePut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_HOMEMESSAGE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutHomemessagesOrdre(action) {
	try {
		const result = yield fromApi.homemessagesOrdrePut(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_HOMEMESSAGES_ORDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelHomemessage(action) {
	try {
		const result = yield fromApi.homemessageDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_HOMEMESSAGE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetHomesettings(action) {
	try {
		const result = yield fromApi.homesettingsGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_HOMESETTINGS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutHomesettings(action) {
	try {
		const result = yield fromApi.homesettingsPut(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_HOMESETTINGS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* homemessages() {
	yield takeLatest('POST_HOMEMESSAGE_SAGAS', watchPostHomemessage);
	yield takeLatest('GET_HOMEMESSAGES_SAGAS', watchGetHomemessages);
	yield takeLatest('PUT_HOMEMESSAGE_SAGAS', watchPutHomemessage);
	yield takeLatest('PUT_HOMEMESSAGES_ORDRE_SAGAS', watchPutHomemessagesOrdre);
	yield takeLatest('DEL_HOMEMESSAGE_SAGAS', watchDelHomemessage);
	yield takeLatest('GET_HOMESETTINGS_SAGAS', watchGetHomesettings);
	yield takeLatest('PUT_HOMESETTINGS_SAGAS', watchPutHomesettings);
}

export default function* rootSaga() {
	yield all([homemessages()]);
}
